import LastUpdateIcon from './LastUpdateIcon'

export default LastUpdateIcon
